<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :destroy-on-close="true"
  >
    <div>
      <p class="md:text-2xl text-center -mt-10 text-root-2 font-bold mb-3">
        Swap Details
      </p>
      <p class="text-base font-normal">You're about to swap:</p>
      <div class="mt-4">
        <div class="flex justify-between items-center mb-4">
          <p class="text-fg-muted text-base font-normal">Currencies</p>
          <div class="flex items-center gap-x-4">
            <div class="flex items-center gap-x-2">
              <currency-icons
                :currency="getCurrencyCountry(swapDetails.fromCurrency)"
              />
              <p>{{ swapDetails.fromCurrency }}</p>
            </div>
            <swap-funds-icon />
            <div class="flex items-center gap-x-2">
              <currency-icons
                :currency="getCurrencyCountry(swapDetails.toCurrency)"
              />
              <p>{{ swapDetails.toCurrency }}</p>
            </div>
          </div>
        </div>
        <div class="flex justify-between items-center mb-4">
          <p class="text-base text-black font-bold">From Amount</p>
          <p class="text-base text-black font-extrabold">
            {{ addComma(swapDetails.amount) }} {{ swapDetails.fromCurrency }}
          </p>
        </div>
        <div class="flex justify-between items-center mb-4">
          <p class="text-base text-black font-bold">To Amount</p>
          <p class="text-base text-black font-extrabold">
            {{ addComma(swapDetails.toAmount) }} {{ swapDetails.toCurrency }}
          </p>
        </div>
        <div class="flex justify-between items-center mb-4">
          <p class="text-base text-black font-normal">Exchange Rate</p>
          <div class="bg-info-subtle text-primary p-1.5 rounded-xl">
            1
            {{
              !this.isDivisionOperator ? country.currency : country2.currency
            }}
            = {{ exchangeRateBase }}
            {{
              !this.isDivisionOperator ? country2.currency : country.currency
            }}
          </div>
        </div>
        <div class="flex justify-between items-center mb-4">
          <p class="text-base text-black font-normal">Our fees</p>
          <p class="text-base text-black font-bold">0</p>
        </div>
        <div class="flex justify-between items-center mb-4">
          <p class="text-base text-black font-normal">Amount Converted</p>
          <p class="text-base text-black font-normal">
            {{ addComma(swapDetails.amount) }} {{ swapDetails.fromCurrency }}
          </p>
        </div>
        <div class="flex justify-between items-center mb-4">
          <p class="text-base text-black font-normal">You will receive</p>
          <p class="text-base text-black font-bold">
            {{ addComma(swapDetails.toAmount) }} {{ swapDetails.toCurrency }}
          </p>
        </div>
        <el-button
          class="bg-primary w-full py-3.5 mt-4 text-white rounded-md text-sm font-normal"
          @click="initiateSwap"
          :loading="isLoading"
          >{{ isLoading ? 'Swapping...' : 'Confirm' }}</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import exchangeRateBase from '@/mixins/localDeposit.js'
import { GetCurrencyCountry, ParseMoneyAll, AddComma } from '@/utils/helpers.js'
export default {
  mixins: [exchangeRateBase],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breakpoints,
      isLoading: false
    }
  },
  components: {
    SwapFundsIcon: () => import('@/assets/v2/icons/SwapFundsIcon.vue'),
    CurrencyIcons: () => import('@/assets/icons/CurrencyIcons.vue')
  },
  methods: {
    addComma (val) {
      return AddComma(val.toString())
    },
    handleClose () {
      this.$emit('closeDialog')
    },
    async initiateSwap () {
      this.isLoading = true
      this.$emit('confirmSwapDeposit')
    },
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    },
    parseMoneyAll (amount, currency) {
      return ParseMoneyAll(amount, currency)
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '30%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    swapDetails () {
      return this.$store.state.transactions.swapDetails
    }
  }
}
</script>

<style scoped>
>>> .el-dialog {
  border-radius: 16px;
  padding: 5px;
  background-color: white;
}
>>> .el-dialog__close .el-icon .el-icon-close {
  color: black !important;
}
</style>
